import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import { translate } from 'react-i18next'
import { searchProperties } from '../../sources/SearchSource'
import AuthActions from '../../actions/AuthActions'
import { Metrics } from '../../Themes'
import Navbar from '../../components/Navbar'
import SearchableDropdown from '../../components/SearchableDropdown'
import Pangea from '../../svg-icons/Pangea'
import Avatar from '../../components/Avatar'
import DropdownLinkContainer from '../../components/DropdownLinkContainer'

const SearchContainer = styled.div`
  width: 450px;
  padding-top: 10px;
  margin-left: ${Metrics.margins.larger};

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    width: calc(${Metrics.components.mobileMenu} - 40px);
    padding-top: 0;
    margin-left: ${Metrics.margins.base};
  }
`

const CustomLogo = styled(Pangea)`
  width: 50px;
  height: 50px;
`

class NavbarWrapper extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeDropdown: null,
      size: window.screen.availWidth,
      properties: [],
      search: '',
      mobileMenu: false
    }

    this.handleBlur = this.handleBlur.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this)
    this.selectDropdown = this.selectDropdown.bind(this)
    this.selectRoute = this.selectRoute.bind(this)
  }

  componentWillMount () {
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
  }

  handleBlur () {
    setTimeout(() => {
      this.setState({ activeDropdown: null })
    }, 200)
  }

  handleSearch (event) {
    const value = event.target.value
    this.setState({ search: value }, () => {
      let query = {
        or: [
          { title: { startsWith: value } },
          { description: { startsWith: value } }
        ],
        published: true,
        sold: false
      }

      searchProperties(query)
        .then(response => this.setState({ properties: response.data }))
        .catch(console.error)
    })
  }

  handleSelect (property) {
    const { router } = this.props
    this.setState({ mobileMenu: false, search: '' }, () =>
      router.replace(`/property/${property.id}`)
    )
  }

  selectRoute (route) {
    const { router } = this.props
    this.setState({ mobileMenu: false, activeDropdown: null }, () =>
      router.replace(route)
    )
  }

  toggleMobileMenu () {
    this.setState({ mobileMenu: !this.state.mobileMenu })
  }

  selectDropdown (el) {
    this.setState({
      activeDropdown: this.state.activeDropdown === el ? null : el
    })
  }

  updateDimensions () {
    this.setState({ size: window.screen.availWidth })
  }

  render () {
    const { router, user, t } = this.props
    const { search, properties, mobileMenu, activeDropdown } = this.state

    const links =
      this.state.size < 768
        ? [
            {
              label: t('Search'),
              to: '/search',
              sublinks: [
                {
                  label: t('Continent'),
                  onClick: () => this.selectRoute('/search/region')
                },
                {
                  label: t('List'),
                  onClick: () => this.selectRoute('/search/properties')
                },
                {
                  label: t('Map'),
                  onClick: () => this.selectRoute('/search/map')
                }
              ]
            },
            {
              label: t('Favorite'),
              onClick: () => this.selectRoute('/favorite'),
              sublinks: [
                {
                  label: t('Cards'),
                  onClick: () => this.selectRoute('/favorite/properties')
                },
                {
                  label: t('List'),
                  onClick: () => this.selectRoute('/favorite/list')
                },
                {
                  label: t('Map'),
                  onClick: () => this.selectRoute('/favorite/map')
                }
              ]
            },
            {
              label: t('Search Request'),
              onClick: () => this.selectRoute('/profile/preferences')
            },
            {
              label: t('Profile Info'),
              onClick: () => this.selectRoute('/profile/profile_info')
            },
            {
              label: t('Change Password'),
              onClick: () => this.selectRoute('/profile/security')
            }
          ]
        : [
            {
              label: t('Search'),
              onClick: () => this.selectRoute('/search'),
              sublinks: [
                {
                  label: t('Continent'),
                  onClick: () => this.selectRoute('/search/region'),
                  id: 'region'
                },
                {
                  label: t('List'),
                  onClick: () => this.selectRoute('/search/properties'),
                  id: 'properties'
                },
                {
                  label: t('Map'),
                  onClick: () => this.selectRoute('/search/map'),
                  id: 'map'
                }
              ]
            },
            {
              label: t('Favorite'),
              onClick: () => this.selectRoute('/favorite'),
              sublinks: [
                {
                  label: t('Cards'),
                  onClick: () => this.selectRoute('/favorite/properties'),
                  id: 'properties'
                },
                {
                  label: t('List'),
                  onClick: () => this.selectRoute('/favorite/list'),
                  id: 'list'
                },
                {
                  label: t('Map'),
                  onClick: () => this.selectRoute('/favorite/map'),
                  id: 'map'
                }
              ]
            },
            {
              label: t('Search Request'),
              onClick: () => this.selectRoute('/profile/preferences'),
              id: 'preferences'
            }
          ]

    const profileLinks = [
      {
        label: t('Profile Info'),
        onClick: () => this.selectRoute('/profile/profile_info'),
        id: 'profile_info'
      },
      {
        label: t('Change Password'),
        onClick: () => this.selectRoute('/profile/security'),
        id: 'security'
      },
      { label: t('Logout'), onClick: () => AuthActions.logout() }
    ]

    return (
      <Navbar
        middle={
          <SearchContainer>
            <SearchableDropdown
              placeholder={t('Search properties')}
              value={search}
              options={properties}
              handleSearch={this.handleSearch}
              handleSelect={this.handleSelect}
              accessor={d => d.title}
            />
          </SearchContainer>
        }
        left={
          <CustomLogo
            onClick={() => {
              router.push('/')
            }}
          />
        }
        right={
          <DropdownLinkContainer
            avatar={
              <Avatar
                imageSrc={user.picture}
                size={38}
                onClick={() => this.selectDropdown('user-dropdown')}
                className='avatar'
              />
            }
            open={activeDropdown === 'user-dropdown'}
            sublinks={profileLinks}
          />
        }
        links={links}
        logout={AuthActions.logout}
        toggleMobileMenu={this.toggleMobileMenu}
        mobileMenuOpen={mobileMenu}
        handleBlur={this.handleBlur}
        activeDropdown={activeDropdown}
        selectDropdown={this.selectDropdown}
        selectRoute={this.selectRoute}
      />
    )
  }
}

NavbarWrapper.propTypes = {
  t: PropTypes.func,
  user: PropTypes.object,
  router: PropTypes.object
}

export default translate([ 'common', 'forms', 'search' ], { wait: true })(
  NavbarWrapper
)



// WEBPACK FOOTER //
// ./src/pages/Public/NavbarWrapper.js